import { ObservationsV1IssueKind } from '@spotify/confidence-graphql';

export type IssueKindOption = {
  label: string;
  value: ObservationsV1IssueKind;
};

export const ISSUE_KIND_OPTIONS: readonly IssueKindOption[] = [
  { label: 'Bug', value: ObservationsV1IssueKind.Bug },
  { label: 'Data quality', value: ObservationsV1IssueKind.DataQuality },
  { label: 'Documentation', value: ObservationsV1IssueKind.Documentation },
  { label: 'Feature request', value: ObservationsV1IssueKind.FeatureRequest },
  { label: 'Performance', value: ObservationsV1IssueKind.Performance },
  { label: 'Reliability', value: ObservationsV1IssueKind.Reliability },
  { label: 'Risk', value: ObservationsV1IssueKind.Risk },
  { label: 'Security', value: ObservationsV1IssueKind.Security },
  { label: 'Usability', value: ObservationsV1IssueKind.Usability },
];

export const getIssueKindLabel = (kind: ObservationsV1IssueKind): string =>
  ISSUE_KIND_OPTIONS.find(option => option.value === kind)?.label ?? kind;
